import Vue from 'vue';

export default (el) =>
  new Vue({
    el,
    components: {
      'text-input': () => import('../text-input/text-input.vue'),
      'text-input-alt': () => import('../text-input-alt/text-input-alt.vue'),
      checkbox: () => import('../checkbox/checkbox.vue'),
      'account-forms': () => import('./account-forms.vue'),
    },
    mounted() {
      setTimeout(() => {
        this.$el.classList.add('account-forms-initialized');
      }, 500);
    },
  });
